<template>
  <div>
    <QuotationSelectCompany
      v-model="selectedEconomicGroup"
      :items="listEconomicGroup"
      item-text="nome"
      item-value="id"
      :return-object="true"
      @return="previousStep"
      :filter="filterTaker"
      @updateFilter="filterValue"
    />
    <QuotationFavoriteCompanyTable
      v-if="selectedEconomicGroup"
      :list="listCompany"
      :value="selectedEconomicGroup"
      :loading="loading"
      @selected="nextStep"
      @favorite="updateFavorite"
      :filter="filterTaker"
    />
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3">
          <BaseButton
            v-html="'CANCELAR SOLICITAÇÃO'"
            class="white--text pink"
            width="100%"
            @click="cancelQuotationButton"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </div>
</template>
<script>
import QuotationSelectCompany from "../components/QuotationSelectCompany";
import QuotationFavoriteCompanyTable from "../components/QuotationFavoriteCompanyTable";
import { mapState, mapActions } from "vuex";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import _ from "lodash";
export default {
  name: "QuotationStepCompony",
  data: () => ({
    selectedEconomicGroup: null,
    loading: false,
    filterTaker: null
  }),
  components: {
    QuotationSelectCompany,
    QuotationFavoriteCompanyTable
  },
  mixins: [QuotationMixin, LoadingRequest],
  computed: {
    ...mapState("quotation", ["listEconomicGroup", "listTaker"]),
    listCompany() {
      const list = [...this.listTaker];
      // Devo mostrar primeiro os tomadores favoritos
      // como eles são Boolean, preciso ordenar
      // descrecente para o true aparecer antes
      return _.orderBy(list, ["favorito"], ["desc"]);
    },
    nextQuotationStep() {
      return {
        name: "quotation step insured",
        step: 2
      };
    },
    previousQuotationStep() {
      return {
        name: "quotation step modality",
        step: 1
      };
    }
  },
  created() {
    this.fetchEconomicGroup();
  },
  methods: {
    ...mapActions("quotation", [
      "requestEconomicGroup",
      "requestTaker",
      "updateFavoriteCompaniesList",
      "requestDeadlineByTaker",
      "requestOfficeByEconomicGroup"
    ]),
    ...mapActions(["showAlertNotification"]),
    async updateFavorite(payload) {
      try {
        this.loading = true;
        await this.updateFavoriteCompaniesList(payload);
      } catch (error) {
        this.showAlertNotification({
          message: error.response.data.error_description,
          type: "error"
        });
      } finally {
        this.loading = false;
      }
    },
    fetchEconomicGroup() {
      const payload = {
        modalidade_id: this.readonlyForm.modality.id,
        submodalidade_id: this.readonlyForm.subModality.id
      };
      this.withLoading(this.requestEconomicGroup(payload));
      this.selectedEconomicGroup = this.form.economicGroup;
    },
    async fetchTaker(item) {
      const payload = {
        grupo_id: item,
        modalidade_id: this.readonlyForm.modality.id,
        submodalidade_id: this.readonlyForm.subModality.id
      };
      try {
        this.loading = true;
        await this.requestTaker(payload);
      } catch (error) {
        this.showAlertNotification({
          message: error.response.data.error_description,
          type: "error"
        });
      } finally {
        this.loading = false;
      }
    },
    filterValue(value) {
      this.filterTaker = value;
    },
    nextStep(payload) {
      let payloadDeadline = {
        economicGroup: payload.economicGroup,
        taker: payload.taker,
        modalidade_id: this.readonlyForm.modality.id,
        submodalidade_id: this.readonlyForm.subModality.id
      };
      this.withLoading(
        Promise.all([
          this.requestOfficeByEconomicGroup(payload.economicGroup.id),
          this.requestDeadlineByTaker(payloadDeadline).then(() => {
            this.$emit(
              "updateStep",
              this.payloadQuotation(payload, this.nextQuotationStep)
            );
          })
        ])
      );
    },
    previousStep() {
      let payload = {
        economicGroup: this.selectedEconomicGroup
      };
      this.$emit(
        "updateStep",
        this.payloadQuotation(payload, this.previousQuotationStep)
      );
    }
  },
  watch: {
    selectedEconomicGroup(value) {
      if (value) {
        this.fetchTaker(value.id);
      }
    }
  },
  props: {
    form: {
      type: Object
    },
    readonlyForm: {
      type: Object
    }
  }
};
</script>
<style lang="sass">
.quotation-table-click
  cursor: pointer
</style>
